import React, { useContext, useEffect, useRef, useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import 'assets/styles/common.scss';
import LabelWithInput from 'components/commom/LabelWithInput';
import ReusableTabs from 'components/commom/Tab';
import InputAdornment from '@mui/material/InputAdornment';
import SelectInput from 'components/commom/SelectInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import MailIcon from 'assets/images/WithoutLogin/mail.svg';
import { useNavigate } from 'react-router-dom';
import { login, registerSuccess } from 'routes/AppUrls';
import { useDispatch, useSelector } from 'react-redux';
import { registerUsers } from 'store/register/registerAction';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { getCity } from 'store/getCity/getCityAction';
import { registerStartPost } from 'store/registerGetStart/registerGetStartAction';
import CheckValidation from 'utils/validate';
import AbsolutLogo from 'assets/images/WithoutLogin/absolute-logo.svg';
import ReusableButton from 'components/commom/Button';
import { registerUploadAction } from 'store/registerUpload/registerUploadAction';
import CommonToast from 'components/commom/CommonToast';
import TabSwitch from 'components/commom/SwitchLabelInput';
import { registerTitleType } from 'store/registerTitle/registerTitleAction';

const RegisterMetghod = () => {
  const intl = useIntl();
  const { showToast } = CommonToast();
  const brandImageFileInputRef = useRef([]);
  const { users } = useSelector((state) => state?.registerUserReducer);
  const cityData = useSelector((state) => state?.getCityReducer?.users);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const [tab, setTab] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [formData, setFormData] = useState({
    providerName: '',
    email: '',
    phoneNumber: '',
    state: '',
    city: '',
    stateId: '',
    cityId: '',
    licence_id: '',
    licence_Value: '',
    expire_date: '',
    title: '9',
    titleSlug: 'dermatologist',
    licenceNumber: '',
  });
  const [isError, setIsError] = useState(false);
  const [isErrorPhone, setIsErrorPhone] = useState({
    phone: { error: false, errorMessage: '' },
  });
  const [doctorTitle, setDoctorTitle] = useState([]);
  const registerReducer = useSelector(
    (state) => state?.registerStartReducer?.loading
  );

  const handleInputChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChange = (event) => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      error: true,
      handleErrorFunction: (res) => {},
    };
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: (name === 'state' || name === 'city') && value?.name,
      stateId: name === 'state' ? value?.id : prev.stateId,
      cityId: name === 'city' ? value?.id : name === 'state' ? '' : prev.cityId,
      ...(name === 'state' && { city: '' }),
    }));

    if (name === 'state') {
      dispatch(getCity(tab, value?.id, external));
    }
  };

  const handlePhoneChange = (value, country) => {
    const countryCode = `+${country?.dialCode}`;
    const phoneNumber = value.replace(country?.dialCode, '').trim();

    setPhoneNumber(phoneNumber);
    setCountryCode(countryCode);
  };

  useEffect(() => {
    dispatch(registerUsers(tab));
    getTitleData();
  }, []);

  const tabData = [
    { label: intl.formatMessage({ id: 'United States of America' }) },
    { label: intl.formatMessage({ id: 'Jamaica' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
    dispatch(registerUsers(val));
    setFormData((prev) => ({
      ...prev,
      city: '',
      state: '',
    }));
  };

  const handleBrandImageUpload = (index) => {
    brandImageFileInputRef.current[index]?.click();
  };

  const handleBrandImageFileChange = (e, index) => {
    const file = e.target.files?.[0];
    let Data = new FormData();
    Data.append('filePath', file);

    const external = {
      run: true,
      handleFunction: (res) => {
        const filePath = res?.data?.[0]?.filePath;
        const fileName = filePath ? filePath.split('/').pop() : null;

        setFormData((prev) => ({
          ...prev,
          licence_Value: fileName,
          licence_id: res?.data?.[0]?.id,
        }));
        showToast(res?.message, 'success');
      },
      error: true,
      handleErrorFunction: (res) => showToast(res?.message, 'error'),
    };

    dispatch(registerUploadAction(Data, external));
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
  };

  const handleDateChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      expire_date: event?.target?.value,
    }));
  };

  const hanldeRegister = () => {
    console.log(434343);
    if (!phoneNumber) {
      setIsErrorPhone({
        phone: {
          error: true,
          errorMessage: 'Field is required!',
        },
      });
    } else {
      setIsErrorPhone({
        phone: {
          error: false,
          errorMessage: '',
        },
      });
    }

    formData.phoneNumber = phoneNumber;

    const error = CheckValidation(formData);
    setIsError(error);
    if (error.submit) {
      let body = {
        full_name: formData?.providerName,
        country_code: countryCode,
        contact_number: phoneNumber,
        email: formData?.email,
        address: {
          country: tab,
          state: formData?.stateId,
          city: formData?.cityId,
        },
        medical_licence_id: formData?.licence_id,
        expiry_date: formData?.expire_date,
        title_id: formData?.title,
        licence_number: formData?.licenceNumber,
        registration_number: formData?.licenceNumber,
      };
      dispatch(
        registerStartPost(body, {
          run: true,
          handleFunction: (res) => {
            showToast(res?.message, 'success');
            navigate(registerSuccess(locale));
          },
          error: true,
          handleFailerFunction: (res) => {
            if (
              formData?.providerName !== '' &&
              formData?.countryCode !== '' &&
              formData?.email !== '' &&
              formData?.stateId !== '' &&
              formData?.cityId !== '' &&
              formData?.licence_id !== '' &&
              formData?.expire_date !== ''
            ) {
              showToast(res?.message, 'error');
            }
          },
        })
      );
    }
  };

  const handleCheckboxChange = (e, name, id) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        // setQualificationData(res?.data);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    setFormData((prevState) => ({
      ...prevState,
      [name]: id?.id,
      titleSlug: id?.slug,
    }));
    if (name === 'title') {
      // dispatch(registerQualification(tab, id?.slug, external));
    }
  };

  const getTitleData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setDoctorTitle(res?.data?.[0]?.values);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(registerTitleType('doctor-title', external));
  };

  return (
    <Row className="m-0 p-0 landing-image">
      <Row className="m-0 p-0">
        <Col
          xs={12}
          sm={10}
          md={10}
          lg={12}
          xl={10}
          xxl={10}
          className="m-auto"
        >
          <Row>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              xxl={4}
              className="my-auto"
            >
              <div>
                <Image src={AbsolutLogo} alt={'icon'} />
              </div>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={7}
              xl={7}
              xxl={7}
              className="bg-light-100 sm:m-auto mb-20 sm:mb-0 mt-md-3"
            >
              <div class="p-24">
                <p className="main-heading p-0 m-0 family_outfit_semiBold_600">
                  Get Started
                </p>
                <Row>
                  <Col sm={12} className="pt-24">
                    <LabelWithInput
                      label="Name"
                      placeholder="Provider Name"
                      name="providerName"
                      type="text"
                      value={formData?.providerName}
                      onChange={(e) => handleInputChange(e, 'providerName')}
                      errorText={
                        isError &&
                        isError?.providerName?.error &&
                        isError?.providerName?.errorMessage
                      }
                    />
                  </Col>
                  <Col sm={12} className="pt-24">
                    <div className="pt-8">
                      <TabSwitch
                        label={'Title'}
                        tabs={doctorTitle}
                        selectedTabValue={formData?.title}
                        tranferData={(e, value) =>
                          handleCheckboxChange(e, 'title', value)
                        }
                      />
                    </div>
                  </Col>
                  <Col sm={12} className="pt-22">
                    <p className="fs-18 lh-23 fc-3C3C3C family_outfit_semiBold_600 p-0 m-0">
                      Contact Details
                    </p>
                  </Col>
                  <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="pt-12">
                    <LabelWithInput
                      label="Email ID"
                      placeholder="Email ID"
                      name="email"
                      type="text"
                      value={formData?.email}
                      onChange={(e) => handleInputChange(e, 'email')}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Image
                              src={MailIcon}
                              alt="icon"
                              style={{ cursor: 'pointer' }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      errorText={
                        isError &&
                        isError?.email?.error &&
                        isError?.email?.errorMessage
                      }
                    />
                  </Col>
                  <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="pt-8">
                    <div>
                      <label
                        htmlFor="phone-input"
                        className="fs-14 family_outfit_regular_400 lh-176 fc-3C3C3C"
                      >
                        Mobile Number
                      </label>
                      <PhoneInput
                        id="phone-input"
                        country={'us'}
                        inputProps={{
                          name: 'phoneNumber',
                          required: true,
                        }}
                        name={'phoneNumber'}
                        value={`${countryCode}${phoneNumber}`}
                        onChange={(value, country) =>
                          handlePhoneChange(value, country)
                        }
                        placeholder="Enter phone number"
                        inputClass="custom-input-register"
                        containerClass="custom-container-register"
                      />
                      {isErrorPhone?.phone?.error && (
                        <div
                          className="fs-16 family_outfit_regular_400"
                          style={{
                            color: 'red',
                          }}
                        >
                          {isErrorPhone?.phone?.errorMessage}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="pt-12">
                    <div>
                      <LabelWithInput
                        label="Registration Number"
                        placeholder="Registration Number"
                        type="text"
                        name="licenceNumber"
                        borderBottomShow={'1px solid #EFE3D7'}
                        value={formData?.licenceNumber}
                        onChange={(e) => handleInputChange(e, 'licenceNumber')}
                        errorText={
                          isError &&
                          isError?.licenceNumber?.error &&
                          isError?.licenceNumber?.errorMessage
                        }
                      />
                    </div>
                  </Col>
                  <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="pt-12">
                    <div
                      className="d-flex flex-column"
                      style={{ borderBottom: '1px solid #efe3d7' }}
                    >
                      <label className="fs-14 family_outfit_medium_500 mb-2 fc-292D32">
                        {`Upload ${formData?.title === 9 ? 'medical' : formData?.title === 10 ? 'Spa' : ''} licence`}
                      </label>

                      <div className="d-flex pb-15">
                        <input
                          ref={brandImageFileInputRef}
                          type="file"
                          accept=".png, .jpg, .jpeg, .gif, .mp4, .pdf"
                          disabled={false}
                          style={{ display: 'none', width: '100%' }}
                          onChange={handleBrandImageFileChange}
                        />
                        <label
                          className="cursor-pointer d-flex align-items-center"
                          onClick={() =>
                            brandImageFileInputRef.current?.click()
                          }
                        >
                          {formData?.licence_Value ? (
                            <div className="pl-8 pt-0.5 fs-14 lh-176 fc-5B88E9 family_outfit_medium_500 underline decoration-1">
                              {formData?.licence_Value}
                            </div>
                          ) : (
                            <div className="d-flex">
                              <div className="pl-8 pt-0.5 fs-14 lh-176 fc-C56616 family_outfit_medium_500 underline decoration-1 ...">
                                Upload file
                              </div>
                            </div>
                          )}
                        </label>
                      </div>
                    </div>
                    {isError?.licence_Value?.error && (
                      <div
                        className="fs-16 family_outfit_regular_400"
                        style={{
                          color: 'red',
                        }}
                      >
                        {isError?.licence_Value?.errorMessage}
                      </div>
                    )}
                  </Col>
                  <Col sm={12} md={6} lg={6} xl={6} xxl={6} className="pt-12">
                    <div>
                      <LabelWithInput
                        label="Licence expire date"
                        placeholder="Email ID"
                        type="date"
                        borderBottomShow={'1px solid #EFE3D7'}
                        value={formData?.expire_date}
                        onChange={(e) => handleDateChange(e)}
                        errorText={
                          isError &&
                          isError?.expire_date?.error &&
                          isError?.expire_date?.errorMessage
                        }
                        min={getTodayDate()}
                      />
                    </div>
                  </Col>
                  <Col sm={12} className="pt-20">
                    <p className="fs-18 lh-23 fc-3C3C3C family_outfit_semiBold_600 p-0 m-0">
                      Location of Practice
                    </p>
                  </Col>
                  <Col sm={12} className="pt-8">
                    <p className="fs-14 lh-176 fc-292D32 family_outfit_regular_400 p-0 m-0">
                      Country
                    </p>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8} className="pt-04">
                    <ReusableTabs
                      tabs={tabData}
                      defaultTab={tab}
                      currentTab={(val) => handleTabChange(val)}
                      background={'#864629'}
                      color={'#FFFFFF'}
                      tabColor={'#998A7B'}
                      completeColor={'#FFFFFF'}
                    />
                  </Col>
                  <Row className="m-0 p-0">
                    <Col md={6} lg={6} xl={6} xxl={6} className="pt-16">
                      <p className="fs-14 lh-176 fc-292D32 family_outfit_regular_400">
                        State
                      </p>
                      <SelectInput
                        placeholder={intl.formatMessage({
                          id: 'State',
                        })}
                        name={'state'}
                        value={formData?.state}
                        data={users?.data}
                        onChange={(e) => handleChange(e)}
                        errorText={
                          isError &&
                          isError?.state?.error &&
                          isError?.state?.errorMessage
                        }
                      />
                    </Col>
                    <Col md={6} lg={6} xl={6} xxl={6} className="pt-16">
                      <p className="fs-14 lh-176 fc-292D32 family_outfit_regular_400">
                        City
                      </p>
                      <SelectInput
                        placeholder={intl.formatMessage({
                          id: 'City',
                        })}
                        name={'city'}
                        value={formData?.city}
                        data={cityData?.data}
                        onChange={(e) => handleChange(e)}
                        disabled={!formData?.state?.length}
                        errorText={
                          isError &&
                          isError?.city?.error &&
                          isError?.city?.errorMessage
                        }
                      />
                    </Col>
                  </Row>
                </Row>
                <div className="pt-32">
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="18px"
                    fontWeight="600"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241  "
                    fontFamily="outfit_semiBold"
                    onClick={() => {
                      !registerReducer && hanldeRegister();
                    }}
                    loading={registerReducer}
                  >
                    <FormattedMessage id="Submit" />
                  </ReusableButton>
                </div>
                <div className="main-description flex justify-center pt-20 fs-18 family_outfit_regular_400 lh-27 fc-7F7F7F">
                  Already Register? Click Here To
                  <span
                    className="underline underline-offset-1 pl-1 cursor-pointer ... family_outfit_semiBold_600"
                    onClick={() => navigate(login(locale))}
                  >
                    Login
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Row>
  );
};

export default RegisterMetghod;
